const ip = {
  id: 0,
  ip: ''
}

export default ip
